"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTabIconWrapper = exports.StyledTabButton = exports.StyledTabListItem = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const tokens_1 = require("../../../../styles/tokens");
const getTabButtonColourStyles = (selected) => {
    if (selected) {
        return {
            backgroundColor: tokens_1.COLOURS.transparent,
            color: tokens_1.COLOURS.greyscale.night,
        };
    }
    return {
        backgroundColor: tokens_1.COLOURS.transparent,
        color: tokens_1.COLOURS.greyscale.metal,
    };
};
const getTabButtonHoverBackgroundColour = () => {
    return tokens_1.COLOURS.primary.blue["10"];
};
const getTabButtonSelectedStyles = (selected) => {
    if (selected) {
        return tokens_1.COLOURS.primary.blue["130"];
    }
    return tokens_1.COLOURS.greyscale.silver;
};
exports.StyledTabListItem = styled_components_1.default.li `
    padding: 0.25rem;
    position: relative;
    border-bottom: solid 4px
        ${({ selected }) => getTabButtonSelectedStyles(selected)};
`;
// N.B. styling taken partially from button component, may need to adjust padding if icons are added
exports.StyledTabButton = styled_components_1.default.button `
    position: relative;
    display: flex;
    align-items: center;
    white-space: nowrap;
    padding: ${tokens_1.BUTTON_FORM_FIELDS_PADDING["text"]["medium"]};
    border-radius: ${tokens_1.BORDERS.radius};
    border: 1px solid transparent;
    margin-bottom: 1px;

    ${({ selected }) => {
    return getTabButtonColourStyles(selected);
}}
    transition: background-color 0.2s ease;

    &:hover {
        cursor: pointer;
        background-color: ${getTabButtonHoverBackgroundColour()};
        transition: background-color 0.2s ease;
    }

    &:focus {
        border: 1px solid ${tokens_1.COLOURS.greyscale.night};
        background-color: ${getTabButtonHoverBackgroundColour()};
    }
`;
exports.StyledTabIconWrapper = styled_components_1.default.span `
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: ${tokens_1.SIZES[0.5]};
`;
//# sourceMappingURL=Tab.styles.js.map